import apiClient from '@u/apiClient'
import GetRoleListController from '@/wayfinder/actions/App/Http/Controllers/Role/GetRoleListController'
import GetRoleByIdController from '@/wayfinder/actions/App/Http/Controllers/Role/GetRoleByIdController'
import CreateRoleController from '@/wayfinder/actions/App/Http/Controllers/Role/CreateRoleController'
import UpdateRoleController from '@/wayfinder/actions/App/Http/Controllers/Role/UpdateRoleController'
import DeleteRoleController from '@/wayfinder/actions/App/Http/Controllers/Role/DeleteRoleController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    if ('new_id' in payload) {
      payload.successCallback(payload.new_id)
    } else {
      payload.successCallback()
    }
  }
}

export default {
  // region fetch

  fetchRoleList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetRoleListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewRole({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'role' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchRoleById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetRoleByIdController.get({ role: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeNewRole: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateRoleController.post(), payload.role)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateRole: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateRoleController.put({ role: payload.id }), payload.role)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deleteRoleById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteRoleController.delete.delete({ role: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  undoDeleteRoleById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteRoleController.undo.delete({ id: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
